<script setup lang="ts">
/**
 * "Switch to Slow" (MAR-1390 round 3): shown under a turn the gateway stopped because the free plan's
 * Fast (chat) allowance is spent. Slow runs on Gemma under its own allowance, so it is what the user
 * has left; pressing the button sets the selector to it. Nothing switches by itself (decided by Alex
 * 2026-10-27). Once the selector is on Slow there is nothing to offer, and the button goes.
 */
import { useModelSelector } from '~/composables/useModelSelector'

const { t } = useI18n()
const { modelId, setModel } = useModelSelector()
</script>

<template>
  <div v-if="modelId !== 'slow'" class="mt-2 flex flex-wrap items-center gap-2 text-[13px] text-muted-foreground">
    <span>{{ t('chat.switchToSlow.hint') }}</span>
    <button
      type="button"
      data-testid="chat-switch-to-slow"
      class="rounded-md border border-border bg-background px-3 py-1 text-xs font-medium text-foreground hover:bg-muted transition-colors cursor-pointer"
      @click="setModel('slow')"
    >
      {{ t('chat.switchToSlow.button') }}
    </button>
  </div>
</template>
